<template>
  <component :is="comp"></component>
</template>

<script lang="ts" setup>
import { PropType } from 'vue'
import { triggerToTableDisplay } from '@/components/Workflows/Approvals/utilities/triggerToTableDisplay'
import { ApprovalTrigger } from '@/gql/graphql'

const props = defineProps({
  trigger: {
    type: String as PropType<ApprovalTrigger>,
    required: true,
  },
})

const comp = triggerToTableDisplay(props.trigger) as any
</script>
